// extracted by mini-css-extract-plugin
export default {"root":"CAGu54dC5ITc524CCIF5","frameContainer":"TD4_ZeKBVkI4FcmMKNFg","frame":"qqgIcIu6h7L4XQOiJ_hR","placeHolderShimmer":"uPOuBhOmrnySlEBvSpmd"};